import { render, staticRenderFns } from "./MpAccount.vue?vue&type=template&id=c8f0a546&scoped=true&"
import script from "./MpAccount.vue?vue&type=script&lang=js&"
export * from "./MpAccount.vue?vue&type=script&lang=js&"
import style0 from "./MpAccount.vue?vue&type=style&index=0&id=c8f0a546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f0a546",
  null
  
)

export default component.exports